var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"md":"12"}},[_c('b-card',{staticClass:"card-congratulations text-center"},[(this.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }